import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import { Auth0Provider } from '@auth0/auth0-react';
import { UserProvider } from './components/providers/user-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { EnvProvider } from './components/providers/env-provider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Users } from './app/user/user-container';
import './App.css';
import { ThemeProvider } from './components/providers/theme-provider';
import { Toaster } from './components/ui/sonner';
import Header from './app/header/header';
import { PlannersTable } from './app/planners-list';
import { Jobs } from './app/jobs/jobs';
import { NotFound } from './app/not-found/not-found';

import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/card/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/aspect-ratio-box/dist/style.css';
import '@ingka/image/dist/style.css';
import '@ingka/variables/dist/style.css';
import '@ingka/text/dist/style.css';
import '@ingka/video-player/dist/style.css';
import { CreatePlannerPage } from './app/planner/CreatePlannerPage';
import { ViewPlannerPage } from './app/planner/ViewPlannerPage';
import { DraftPlannerPage } from './app/planner/DraftPlannerPage';
import { RequestUserAccess } from './app/user/RequestUserAccess';
import ReviewUserAccessRequest from './app/user/ReviewUserAccessRequest';
import FragmentPreview from './app/previewComponents/publishedFragmentPreview/FragmentPreview';
import { PlannerRestore } from './app/planner-restore/planner-restore';
import Auth0Initializer from './services/auth/Auth0Initializer';
import { appEnv } from './config/env';

const queryClient = new QueryClient();

async function init() {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={appEnv.auth0.domain}
        clientId={appEnv.auth0.clientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: appEnv.auth0.audience,
        }}
        cacheLocation='localstorage'
      >
        <Auth0Initializer>
          <QueryClientProvider client={queryClient}>
            <EnvProvider>
              <UserProvider>
                <ThemeProvider defaultTheme='light' storageKey='vite-ui-theme'>
                  <div className='site-container'>
                    <BrowserRouter>
                      <Routes>
                        <Route
                          path='/'
                          element={
                            <>
                              <Header />
                              <PlannersTable />
                            </>
                          }
                        />
                        <Route
                          path='/planner/view/:env/:plannerId'
                          element={<ViewPlannerPage />}
                        />
                        <Route
                          path='/planner/create'
                          element={<CreatePlannerPage />}
                        />
                        <Route
                          path='/planner/draft'
                          element={<DraftPlannerPage />}
                        />
                        <Route
                          path='/users'
                          element={
                            <>
                              <Header />
                              <Users />
                            </>
                          }
                        />
                        <Route
                          path='/request-user-access'
                          element={
                            <>
                              <Header />
                              <RequestUserAccess />
                            </>
                          }
                        />
                        <Route
                          path='/backup'
                          element={
                            <>
                              <Header />
                              <PlannerRestore />
                            </>
                          }
                        />
                        <Route
                          path='/review-user-access'
                          element={
                            <>
                              <Header />
                              <ReviewUserAccessRequest />
                            </>
                          }
                        />
                        <Route
                          path='/jobs'
                          element={
                            <>
                              <Header />
                              <Jobs />
                            </>
                          }
                        />
                        <Route
                          path='/fragment-preview'
                          element={
                            <>
                              <Header />
                              <FragmentPreview />
                            </>
                          }
                        />
                        <Route path='*' element={<NotFound />} />
                      </Routes>
                    </BrowserRouter>
                  </div>
                  <Toaster richColors />
                </ThemeProvider>
              </UserProvider>
            </EnvProvider>
          </QueryClientProvider>
        </Auth0Initializer>
      </Auth0Provider>
    </React.StrictMode>,
  );
}

init().catch(console.error);
